import React, { useState, useEffect } from 'react';
import { HealthConditionOptions } from '../../../../Constants/Constants';

const PleaseDescribe = ({ onNext, answers, stepKey }) => {
  // Get the keys from HealthConditionOptions constant
  const optionKeys = Object.keys(HealthConditionOptions);
  
  // Parse initial values - check for text input with colon separator
  const initialSelection = (answers[stepKey] || []).filter(a => {
    if (typeof a === 'string' && a.includes(':')) {
      // Extract just the key part before the colon
      const key = a.split(':')[0];
      return optionKeys.includes(key);
    }
    return optionKeys.includes(a);
  }).map(a => {
    if (typeof a === 'string' && a.includes(':')) {
      return a.split(':')[0]; // Return just the key part
    }
    return a;
  });
  
  // Find description from colon-separated values or standalone text
  let extractedDescription = '';
  (answers[stepKey] || []).forEach(a => {
    if (typeof a === 'string' && a.includes(':')) {
      const [key, text] = a.split(':');
      if (key === '453' || !optionKeys.includes(key)) {
        extractedDescription = text;
      }
    } else if (!optionKeys.includes(a) && typeof a === 'string') {
      extractedDescription = a;
    }
  });

  const [selection, setSelection] = React.useState(initialSelection);
  const [description, setDescription] = React.useState(extractedDescription);
  const [error, setError] = React.useState('');

  const handleSelect = (key) => {
    setError('');
    const newSelection = selection.includes(key)
      ? selection.filter(answer => answer !== key)
      : [...selection, key];
    setSelection(newSelection);
  };

  const handleDescriptionChange = (e) => {
    setError('');
    setDescription(e.target.value);
  };

  const handleContinue = () => {
    console.log('Selected Health Conditions:', selection);
    console.log('Description:', description);
    
    if (selection.length === 0 && description.trim() === '') {
      setError('Please select at least one option or provide a description.');
      return;
    }

    const finalAnswer = [];
    
    // Add selected options
    selection.forEach(key => {
      finalAnswer.push(key);
    });
    
    // If there's a description, add it with a special key (using the last option key + description)
    if (description.trim() !== '') {
      // Use a special key for description, similar to EmploymentSts pattern
      finalAnswer.push(`453:${description.trim()}`);
    }
    
    onNext(finalAnswer);
  };

  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Please tick any that apply</h2></div>
      <div className="qs-card__body">
        <ul className="qs-list">
          {Object.entries(HealthConditionOptions).map(([key, value]) => (
            <li key={key}>
              <button 
                className={`qs-check qs-check--left ${selection.includes(key) ? 'is-on' : ''}`} 
                onClick={() => handleSelect(key)}>
                  {value}
              </button>
            </li>
          ))}
        </ul>
        <p className="qs-card__sub" style={{ marginTop: '8px' }}>Please describe in your own words how this affected you</p>
        <input
          className="qs-input is-show"
          type="text"
          placeholder="Please describe"
          value={description}
          onChange={handleDescriptionChange}
        />
        {error && <p className="qs-error-message" style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        <div className="qs-actions">
            <button type="button" className="qs-btn qs-btn--primary" onClick={handleContinue} data-quest-id="step15">Continue <span className="qs-arrow">→</span></button>
        </div>
      </div>
    </>
  );
};

export default PleaseDescribe;
